<!-- <template>
  <div id="sidebar-menu" v-if="!loading" style="border-top : 1px solid #eeeeee; border-right : 1px solid #eeeeee; margin-top: 11px;">
    <v-list style="margin-top: -9px; margin-bottom: -16px">
      <template v-for="item in items">
        <v-list-group
          v-if="item.items.length > 0 && item.show && item.node_type === 'group'"
          :key="item.text"
          :prepend-icon="item.icon"
          :value="item.expand"
          no-action
        >
          <template v-slot:activator link :to="item.to">
              <v-list-item-content>
                <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
              </v-list-item-content>
          </template>
          <v-list-item
            v-for="child in item.items"
            :key="child.text"
            link
            :to="child.to"
            v-show="child.show"
            @click="updateOnClick(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="$t(child.text)"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>


        <v-list-item
          v-else
          :key="item.text"
          v-show="item.show"
          link
          :to="item.to"
          @click="updateOnClick(item)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-text="$t(item.text)"></v-list-item-title>
          </v-list-item-content>      
        </v-list-item>
      </template>
    </v-list>

    <v-list v-model="tpl_key">
      <v-divider v-if="showExpertModules"></v-divider>

      <v-list-group v-model="tpl_key" v-if="showExpertModules" color="white" no-action prepend-icon="mdi-microscope">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t('_modules_experts_') }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          nav
          v-for="item in changedexpertmodule()"
          :key="item.text"
          link
          class="border-bottom"
          :style="unablelist.includes(item.text) ? { backgroundColor: '#f5f5f5' } : {}"
          @click.prevent="handleClick(item)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
          <v-icon v-if="testversion(item) && !unablelist.includes(item.text)" right style="color: #3a9ffd;">mdi-new-box</v-icon>
          <icon
            v-if="item.mode_ac && !unablelist.includes(item.text) && auditac == true"
            right
            style="color: green;"
            :icon="checklistIcon['inv']['icon']"
            :height="checklistIcon['inv']['height']"
          />
          <span v-if="unablelist.includes(item.text)" class="icon-badge">NA</span>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import api from "../../api/api";
import store from "../../store";
import { Icon } from '@iconify/vue2'


export default {
  components: {
    Icon
  },
  name: "SidebarMenu",

  data() {
    return {
      activatelist: false,
      loading: false,
      hasPdfReport: false,
      installation: null,
      checklistIcon: {},
      items: [],
      expertModules: [],
      expertModulesName: [],
      security_rules: null,
      showExpertModules: false,
      tpl_key: 0,
      lastversion: 1,
      auditac: false,
      unablelist: []
    }

  },

  async created() {
    if (store.getters.authenticated) {
      await api.currentUser().then((res) => {
        this.security_rules = res['data']['policies']
        this.loadMenu()
      })
    }
  },

  mounted() {
    this.getChecklistIcon();
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),
  },

  watch: {
    '$route': {
      handler() {
        if (Object.keys(this.$route.params).length > 0) {
          this.installation = this.installations.find((x) => x.id == this.cur_install_id)
        }
        this.loadMenu()
      },
      immediate: true,
      deep: true
    },

    '$root.$i18n.locale': {
      handler() {
        this.loadMenu()
      }
    },

    'cur_install_id': {
      handler() {
        this.showExpertModules = (this.cur_install_id != null)
        // if (this.showExpertModules) this.getReportModules()
        this.loadMenu()
      }
    }
  },

  methods: {
    handlesmartguard(item) {
      let to = `/smart-guard/${item.installation_id}`;
      if (this.shouldNavigate(item)) {
        this.$store.commit("SET_CUR_INSTALL_ID", item.installation_id);
        this.$router.push(to);
      }
    },

    handleClick(item) {
      if (this.shouldNavigate(item)) {
        this.$router.push(item.to);
      }
    },

    shouldNavigate(item) {
      return !this.unablelist.includes(item.text);
    },

    getChecklistIcon() {
      this.$store.getters.constants['alarm'].forEach((checklist) => {
        this.checklistIcon[checklist.key] = checklist['icon']
      })     
    },

    securityCheck(item, policies) {
      if (policies) return (policies[item] === true)
      return false
    },

    additemsinstallations() {
      this.installations.forEach((element) => {
        this.items[2].items.push(element.installation_name);
      });
      return this.items;
    },

    getMenu() {
      return this.installations.find(
          x => x.id == this.cur_install_id
      )?.target_menu
    },

    changedexpertmodule() {
      let newexpertmod = [];

      this.installations.forEach((check) => {
        if (check.installation_id == this.cur_install_id) {
          if (check.dc_analysis == false) {
            this.auditac = true;
          } else {
            this.auditac = false;
          }
        }
      });
      if (this.expertModules[0]?.analysis_types) {
        if (this.auditac == true) {
          this.expertModules.forEach((n) => {
            if (n.analysis_types && n.analysis_types.includes('ac')) {
              newexpertmod.push(n);
            }
          });
        }
        if (this.auditac == false) {
          this.expertModules.forEach((n) => {
            if (n.analysis_types && n.analysis_types.includes('dc')) {
              newexpertmod.push(n);
            }
          });
        }        
      } else {
        this.expertModules.forEach((n) => {
          newexpertmod.push(n);
        });
      }

      // this.lastversion = this.expertModules[0]['last_version'];
      if (newexpertmod.length > 0) {
        return newexpertmod;
      } else {
        return this.expertModules;
      }
    },

    testversion(item) {
      if (item.comp_min_version == this.lastversion || item.comp_min_version == (this.lastversion - 0.1)) {
        return true;
      } else {
        return false;
      }
    },

    loadMenu() {
      this.expertModules = []
      this.expertModulesName = []

      // if (this.items === undefined || this.items === null) return false
      this.refreshMenu()

      if (this.installation !== undefined && this.installation !== null) {
        this.hasPdfReport = (this.installation.pdf_link.length > 0)
        this.showExpertModules = (this.cur_install_id != null)
        
        if (this.showExpertModules) {
          // this.getReportModules();
          // this.createunablelist();
        } 

        // Set Level 2 dates
        this.$store.dispatch("setInstallationNiv2Date", {
          start_date: this.installation.audit_start_date,
          end_date: this.installation.audit_end_date
        })
      } else {
        this.hasPdfReport = false
        this.showExpertModules = false
      }
    },

    refreshMenu() {
      this.items = JSON.parse(JSON.stringify(this.constants.menu))
      
      for (let item in this.items) {
        const elm = this.items[item]  
        let t = this.securityCheck(elm.name, this.security_rules)
  
        if (this.cur_install_id != null && this.items[item].to.includes(':id')) {
          const pattern = this.items[item].to
          this.items[item].to = pattern.replace(':id', String(this.cur_install_id))
        }
        
        if (elm.name === 'analyst_mod') {
          t = t && this.cur_install_id != null
        } else if (elm.name === 'pdf_report') {
          t = t && this.hasPdfReport && this.cur_install_id != null
        }

        this.items[item].show = t

        if (elm.items.length > 0) {
          for (let subitem in elm.items) {
            this.items[item].items[subitem].show = this.securityCheck(
                this.items[item].items[subitem].name, this.security_rules)
                
          }
        }
      }
    },


    async createunablelist() {
      await api
        .getListunablemodexp()
        .then((response) => {
          this.unablelist = response.data;
      });
      this.unablelist = this.unablelist.map((element) => this.$t(element));      
    },

    updateOnClick(item) {
      if (item.name !== 'analyst_mod' && item.name !== 'pdf_report') {
        this.$store.commit("SET_CUR_INSTALL_ID", null);
      }
    },



  },
};
</script>

<style lang="scss">
  .v-list .v-list-item--active {
    color:#000 !important;
    border-right: 2px #F39200 solid;
    font-weight: bold;
  }

  .v-list-item__title {
    line-height: 0.9em;
    font-size: 0.9rem;
  }

  .v-list-item {
    min-height: 10px;
  }

  .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
    padding-left: 25px;
  }

  .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 15px;
  }

  .icon-badge {
    position: absolute;
    background-color: #9d9d9d;
    color: white;
    right: 10px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 3px;
    padding: 2px 5px;
    text-transform: uppercase;
    white-space: nowrap;
  }
</style> -->



<template>
  <div id="sidebar-menu" style="border-top : 1px solid #eeeeee; border-right : 1px solid #eeeeee; margin-top: 11px;">

    <div :class="this.$route.name === 'dashboard-audits' ? 'selectedCaseAudit' : 'unselectedCaseAudit'">
      <router-link to="/" class="routerLink">
        <svg-icon type="mdi" :path="this.pathHome" style="color: black; margin-right: 8px;"></svg-icon>
        <div style="color: black"> {{ $t('_liste_des_audits_') }}</div>
      </router-link>
    </div>
    <div v-if="this.$route.path != '/dashboard-audits'">
      <div @click="toggleConf" class='unselectedCase'>
        <div
          :class="(this.$route.name === 'installation-show-c-a' || this.$route.name === 'installation-show-evenement') ? 'selectedTitle' : 'unselectedTitle'">
          {{ $t('_configuration_') }}</div>
        <svg-icon v-if="this.showConf" type="mdi" :path="this.chevronUpPath"
          style="color: black; margin-right: 8px;"></svg-icon>
        <svg-icon v-if="!this.showConf" type="mdi" :path="this.chevronDownPath"
          style="color: black; margin-right: 8px;"></svg-icon>
      </div>
      <div v-if="this.showConf" :class="this.$route.name === 'installation-show-c-a' ? 'selectedCase' : 'unselectedCase'">
        <router-link :to="{ path: `/installations/show/calepinage-agencement/${this.$route.params.id}` }"
          class="routerLink">
          <div :class="this.$route.name === 'installation-show-c-a' ? 'selectedText' : 'unselectedText'">{{
            $t('_calepinage_et_agencement_') }}</div>
        </router-link>
      </div>
      <div v-if="this.showConf"
        :class="this.$route.name === 'installation-show-evenement' ? 'selectedCase' : 'unselectedCase'">
        <router-link :to="{ path: `/installations/show/evenement/${this.$route.params.id}` }" class="routerLink">
          <div :class="this.$route.name === 'installation-show-evenement' ? 'selectedText' : 'unselectedText'">{{
            $t('_evenement_')}}</div>
        </router-link>
      </div>
      <div :class="this.$route.name === 'installation-visualisation' ? 'selectedCase' : 'unselectedCase'">
        <router-link :to="{ path: `/installations/show/visualisation/${this.$route.params.id}` }" class="routerLink">
          <div :class="this.$route.name === 'installation-visualisation' ? 'selectedTitle' : 'unselectedTitle'">{{
            $t('_visualiser_les_donnees_')}}</div>
        </router-link>
      </div>
    </div>
    <div class="unselectedCaseMode">

      <router-link class="routerLink" :to="this.$route.path === '/dashboard-audits' ? '/tech/dashboard' : '/tech/map/'+$route.params.id">
        <svg-icon type="mdi" :path=this.pathTel style="color: black; margin-right: 8px;"></svg-icon>
        <div style="color: black"> {{ $t('_passer_en_mode_technicien_') }}</div>
      </router-link>

    </div>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiHomeAnalytics, mdiChevronDown, mdiChevronUp, mdiAccountCardOutline } from '@mdi/js';

export default {
  components: {
    SvgIcon
  },

  data() {
    return {
      installation_id: this.$route.params.id,
      pathHome: mdiHomeAnalytics,
      showConf: false,
      chevronDownPath: mdiChevronDown,
      chevronUpPath: mdiChevronUp,
      pathTel: mdiAccountCardOutline,
    }
  },
  methods: {
    toggleConf() {
      this.showConf = !this.showConf
    },
  }
}
</script>

<style scoped>
.routerLink{
    text-decoration: none;
    width: 100%;
    /* background-color: aqua; */
    display: inline-flex; 
    align-items: center; 
    padding: 5px; 
    border-radius: 4px;
}

.unselectedCaseAudit {
  height: 5vh;
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  cursor: pointer;
}

.selectedCaseAudit {
  height: 5vh;
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  background-color: #D9D9D9;
}

.unselectedCase {
  height: 5vh;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* background-color: blueviolet; */
  /* border: 1px solid lightgray;  */
}

.selectedCase {
  height: 5vh;
  display: flex;
  align-items: center;
  background-color: #D9D9D9;
  /* border: 1px solid lightgray;  */
}

.unselectedText {
  color: black;
  margin-left: 20px;
}

.selectedText {
  color: black;
  margin-left: 20px;
  font-weight: 600;
}

.unselectedTitle {
  color: black;
  margin-left: 10px;
}

.selectedTitle {
  color: black;
  margin-left: 10px;
  font-weight: 600;
}

.unselectedCaseMode {
  height: 5vh;
  display: flex;
  align-items: center;
  border: 1px solid lightgray;
  cursor: pointer;
  bottom: 0;
  position: absolute;
  width: 100%;
}
</style>